import ReactLoading from 'react-loading';
import styles from './styles.module.scss';

/**
 * @deprecated `Loader` は非推奨です。代わりに `Spinner` を使用してください。
 * `Spinner` はデザインシステムに準拠した ui/common のローディングコンポーネントです。
 * 既存の利用箇所は順次 Spinner に置き換えていく予定です。
 */
export const Loader: React.FC = () => {
  return (
    <div className={styles.Root}>
      <ReactLoading
        type='spinningBubbles'
        color='#ee853a'
        height='100px'
        width='100px'
        className='mx-auto'
      />
    </div>
  );
};
